import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { MOV_FILTER_OPTIONS } from "../../../shared/constants/pricelist.constants";
import { MOV_FILTER_QUERY_PARAM } from "./mov-filter.constants";

@Component({
    selector: "vsf-mov-filter",
    templateUrl: "./mov-filter.component.html",
})
export class MovFilterComponent implements OnInit, OnDestroy {
    @Input() filtersExpanded = false;
    @Input() loading = false;
    @Output() filterChange = new EventEmitter<string[]>();

    selectedMov: string | null = null;
    readonly movOptions = MOV_FILTER_OPTIONS.map((opt) => {
        const euros = Math.round(opt.max / 100);
        return { value: String(euros), label: `Up to ${euros} €` };
    });

    private readonly destroy$ = new Subject<void>();

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe((params: Params) => {
                const movParam = params[MOV_FILTER_QUERY_PARAM];
                if (movParam) {
                    const ranges = String(movParam).split(",");
                    this.selectedMov = ranges[0] || null;
                } else {
                    this.selectedMov = null;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onMovFilterChange(): void {
        const selectedRanges = this.selectedMov ? [this.selectedMov] : [];
        this.filterChange.emit(selectedRanges);
    }

    clearFilters(): void {
        this.selectedMov = null;
        this.onMovFilterChange();
    }

    hasActiveFilters(): boolean {
        return !!this.selectedMov;
    }
}
